// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__UPhKe","huge":"title_huge__1T4qi","smallText":"title_smallText__r0QfX","mediumText":"title_mediumText__fsWUB","no-margin":"title_no-margin__1OaIH"};